<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华财经小课堂 - 用wh5软件做股票财务分析</div>
        <p class="index-module_textWrap_3ygOc">机构为什么总能在低点买入？ 总能买到好股票？因为投资决策依据的是财务分析。
        </p>
        <p class="index-module_textWrap_3ygOc">机构的研究员对企业财务报表、企业经营情况、行业数据、宏观经济情况等做了深度研究，这才是真正的原因。
        </p>
        <p class="index-module_textWrap_3ygOc">财务分析，需要对财务数据进行清洗、利润脱水、风险甄别、估值分析等大量的数据深加工处理，这个复杂的工作过程，不仅要求你具备专业财务知识，而且还会耗费你大量的时间。</p>
         <p class="index-module_textWrap_3ygOc">wh5作为一款专门的财务分析软件，能够帮助研究员提高工作效率，节省工作时间。
        </p>
        <p class="index-module_textWrap_3ygOc">软件也可以用于散户对网络上的各种荐股，进行排雷和精选的场景。
        </p>
        <p class="index-module_textWrap_3ygOc">本期将介绍wh5软件使用的排雷五大秘籍，讲述如何用工具软件来解析财务报表，帮助你排雷，规避投资风险。
        </p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top" width="18%">题目</th>
                    <th valign="top">内容</th>
                    <th valign="top" width="9%">讲师</th>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">估值研究</td>
                    <td>用溢价倍数进行排雷<br>【描述】利用软件提供的DCF模型（现金流贴现模型）核心框架，根据企业财务数据，计算股票的实际价值。<br>【秘籍】避开溢价倍数大于1的股票。</td>
                    <td rowspan="7"  style="padding:0 5px;text-align:center;text-indent:0">孙健</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">财务画像</td>
                    <td>利用现金流数据排雷<br>【描述】软件已对资产、负债、收益和现金流数据进行深加工结构化处理，直观展示企业经营和业务的情况。<br>【秘籍】避开财务结构不合理、现金流数据不健康的股票。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">利润滤镜</td>
                    <td>利用脱水的利润数据排雷<br>【描述】软件的数据从营运资本投资、资本性支出、非经营性损益、股东权益成本以及递延所得税五个方面对企业利润数据进行脱水，揭示企业真实利润情况。<br>【秘籍】避开利润分析曲线有明显背离的股票。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">风险甄别</td>
                    <td>利用净现比数据排雷<br>【描述】软件提供现金流深加工数据，对企业的运营情况进行深度分析，揭示企业的经营风险。<br>【秘籍】避开净现比为负的股票。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">EVA分析</td>
                    <td>利用EVA数据排雷<br>【描述】软件提供了EVA（经济增加值）分析工具，揭示企业经营的价值创造性，真正能给予股东的回报水平。<br>【秘籍】避开EVA经济附加值低的股票。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <!-- <div>【孙健】&nbsp;文华产品经理</div> -->
            <div  class="index-module_textWrap_3ygOc">
              【孙健】  &nbsp;文华财经大客户服务部产品经理，十年来专注于客户需求整理和产品设计，每年多次在全国范围内举办和参与期货和证券领域的大型授课活动，现主要负责服务机构客户，为专业的投资者提供技术支持，解决实际使用中的问题。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
     padding: 5px 8px;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
.table2 tr td:first-child{
    text-align: left !important;
    padding-left: 10px !important;
}
</style>